import { APIConfiguration } from '@savgroup-front-common/configuration';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import { BaseBackResponse } from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}quotes/answered`;

export interface AnswerQuoteCommandArgs {
  quoteId: string;
  answer: string;
}

export const answerQuoteRequest = (
  payload: AnswerQuoteCommandArgs,
): ApiRequestDescriptor => ({
  url: ENDPOINT,
  config: {
    method: SUPPORTED_METHODS.POST,
    json: { quoteId: payload.quoteId, clientAnswer: payload.answer },
  },
});

export const answerQuoteCommand = async (
  payload: AnswerQuoteCommandArgs,
): Promise<BaseBackResponse> => {
  try {
    return await executeQuery<BaseBackResponse>(answerQuoteRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
